import _ from 'lodash';
import dynamic from 'next/dynamic';
import styled from '@emotion/styled';
import { memo } from 'react';
import { NextPage } from 'next';
import { useDispatch, useSelector } from 'react-redux';

import { initialLists, initialNews, IReduxMember, TChild } from 'src/services/member-auth/redux';
import { convertArrPath, timestamp } from 'src/utils/helper';

import { convertFavorite, convertFollowing, decrementItem, filterFollowing, incrementItem } from 'src/services/member-auth/utils/helper';
import { sendSubscribe } from 'src/services/member-auth/utils';
import { GET } from 'src/services';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { WEB_NAME } from 'src/constants';
const Image = dynamic(import('src/components/image'));

type Props = {
  data?: any;
  showBadge?: boolean;
  showTitle?: boolean;
  showBlurb?: boolean;
  showTimeAgo?: boolean;
  showPublishDate?: boolean;
  showCountView?: boolean;
  showImage?: boolean;
  external?: boolean;
  subscribe?: boolean;
  eventDataLayer?: any;
  user?: any;
};
const CardSubscribe: NextPage<Props> = ({ data, showTitle = true, showBlurb = false, showImage = true, external = false, user, eventDataLayer }) => {
  const _type = 'favoriteCategories';
  const dispatch = useDispatch();
  const selected = useSelector((state: IReduxMember) => state?.member);
  const conditionFollowing = !_.isEmpty(user?.favoriteCategories) ? filterFollowing(user.favoriteCategories.filter((obj: any) => obj['site'] === WEB_NAME)[0]?.categories, data) : false;
  const statusFollowing = !_.isEmpty(user?.favoriteCategories) ? convertFollowing(user.favoriteCategories.filter((obj: any) => obj['site'] === WEB_NAME)[0]?.categories, {
    id: data?.id,
    nameTh: data?.nameTh,
    nameEng: data?.nameEng,
    image: data?.image
  }) : 'ติดตาม';

  /* --------------------------------- HandlerFollow --------------------------------- */
  async function handlerFollow(type: any, data: TChild) {
    try {
      const dataItem = conditionFollowing ? decrementItem(user.favoriteCategories.filter((obj: any) => obj['site'] === WEB_NAME)[0]?.categories || [], data) : incrementItem(user.favoriteCategories.filter((obj: any) => obj['site'] === WEB_NAME)[0]?.categories || [], data);
      if (!_.isEmpty(user)) {
        // const response = await sendSubscribe(user, { tags: user.favoriteTags || [], categories: dataItem || [] });
        // const response = await sendSubscribe(user, { tags: selected.tags || [], categories: dataItem || [] });
        const response = await sendSubscribe(
          user,
          { tags: _.isEmpty(selected.tags) ? user.favoriteTags.filter((obj: any) => obj['site'] === WEB_NAME)[0]?.tags || [] : selected.tags, categories: dataItem || [] },
          user?.favoriteCategories,
          user?.favoriteTags
        );

        if (!_.isEmpty(response)) {
          // console.log(response, 'responseCategories');
          dispatch(initialLists({ type: 'categories', data: response?.favoriteCategories }));
          if (!_.isEmpty(response?.favoriteCategories)) {
            const _categories = response?.favoriteCategories ? convertFavorite(response?.favoriteCategories, 'nameEng') : [];

            const uriCategories = `/api/v1.0/categories/mapping/categories${convertArrPath(_categories, 'name')}&limit=10`;

            const resSubscribe = await GET(uriCategories, false, true);
            if (!_.isEmpty(resSubscribe?.data)) {
              const data = resSubscribe?.data || [];
              dispatch(initialNews({ type: 'articlesCategories', data }));
            }
          }
        }
      }
    } catch (error) {
      if (error instanceof Error) console.error(`${timestamp()} ==========>  handlerFollow ERROR : `, error.message);
    }
  }
  return (
    <CardWrapper className='card-subscribe' showImage={showImage}>
      {showImage && (
        <CardImage>
          <a
            href={data?.link}
            title={data?.title}
            target='_self'
            tabIndex={-1}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                ...eventDataLayer,
                data: {
                  heading: `${statusFollowing}หมวดข่าว-${data?.title}`,
                  ...eventDataLayer.data
                }
              });
              handlerFollow(_type, { id: data?.id, nameTh: data.nameTh, nameEng: data?.nameEng, image: data?.image || null });
            }}
          >
            <Image image={data?.image || '/default.jpg'} title={data?.title || 'card-h'} external={external} />
          </a>
        </CardImage>
      )}
      <CardContent
        title={data?.title}
        tabIndex={-1}
        // ! DATALAYER
        onClick={() => {
          sendDataLayerGlobal({
            ...eventDataLayer,
            data: {
              heading: `${statusFollowing}หมวดข่าว-${data?.nameTh}`,
              ...eventDataLayer.data
            }
          });
          handlerFollow(_type, { id: data?.id, nameTh: data.nameTh, nameEng: data?.nameEng, image: data?.image || null });
        }}
        statusText={conditionFollowing}
      >
        <div className='header'>
          {showTitle && <h3 className='header--item title line-clamp --2'>{data?.nameTh}</h3>}
          {showBlurb && <small className='header--item blurb line-clamp --2'>{data?.abstract || ''}</small>}
        </div>
        <div className='subscribe-button'>
          <button>
            {/* {conditionFollowing ? (
              <div className='correct-symbol'>
                <MdOutlineDone size={16} />{' '}
              </div>
            ) : (
              <IoMdAddCircleOutline size={16} />
            )} */}
            <small>{statusFollowing}</small>
          </button>
        </div>
      </CardContent>
    </CardWrapper>
  );
};

interface ICardWrapper {
  showImage: boolean;
}

interface ICardContent {
  statusText: boolean;
}

const CardWrapper = styled.div<ICardWrapper>`
  cursor: pointer;
  position: relative;
  display: grid;
  width: 100%;
  min-height: 80px;
  grid-template-columns: ${({ showImage }) => (showImage ? '3fr 7fr' : '1fr')};
  column-gap: 10px;

  @media (max-width: 1300px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '3fr 5fr' : '1fr')};
  }
  @media (max-width: 1024px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '2fr 3fr' : '1fr')};
  }
  @media (max-width: 768px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 3fr' : '1fr')};
  }
  @media (max-width: 620px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 2fr' : '1fr')};
  }
  @media (max-width: 425px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 1fr' : '1fr')};
  }
  &:hover {
    img {
      transform: scale(1.1);
    }
    .title {
      background-position: 0;
    }
  }
`;

const CardImage = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  img {
    box-shadow: 0px 0px 2px 0px #b7b7b7;
    display: block;
    width: 100%;
    max-height: 200px;
    aspect-ratio: 16/9;
    object-fit: cover;
    object-position: center;
    transition: 0.6s transform ease-in-out;
    border-radius: 5px;
  }
`;

const CardContent = styled.div<ICardContent>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .header {
    margin-bottom: 8px;
    &--item {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    .title {
      /* font-family: 'Nunito Sans', sans-serif !important; */
      text-transform: capitalize;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.45;

      /* animation */
      background-image: linear-gradient(to right, var(--primary-color), var(--primary-color) 50%, var(--primary-color) 50%);
      background-size: 200% 100%;
      background-position: 100%;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      transition: all 0.4s ease-in-out;
      @media (max-width: 380px) {
        font-size: 14px;
      }
    }

    .blurb {
      font-family: var(--front-thin), sans-serif;
      text-transform: capitalize;
      font-size: 12px;
      line-height: 1.25;

      color: #939393;

      @media (max-width: 767px) {
        font-size: 10px;
        line-height: 1;
      }
    }
  }
  .subscribe-button {
    button {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      z-index: 1;

      display: flex;
      align-items: center;
      justify-content: space-between;
      width: fit-content;
      padding: 10px 20px;
      border: none;
      padding: 6px 10px;
      border-radius: 20px;
      text-transform: capitalize;

      font-size: 18px;
      font-weight: 600;

      transition: all 0.3s;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      background-blend-mode: overlay, normal;
      background: ${({ statusText }) => (statusText ? '#676767' : 'var(--primary-gradient)')};
      small {
        text-transform: capitalize;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        color: #ffff;
        @media (max-width: 767px) {
          font-size: 12px;
        }
      }
      svg {
        color: #fff;
        margin-right: 5px;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        z-index: -2;
        background-blend-mode: overlay, normal;
        background: var(--primary-gradient);
      }
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        height: 100%;
        transition: all 0.3s;
        border-radius: 4px;
        z-index: -1;
        background-blend-mode: overlay, normal;
        background: var(--primary-gradient);
      }
      &:hover {
        &:before {
          width: 100%;
        }
      }
    }
  }

  .footer {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    line-height: 0.2;
    padding-right: 5px;

    &--item {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
    .badge,
    .subscribe {
      background: rgba(255, 255, 255, 0.9);
      padding: 5px 15px;
      border-radius: 5px;
      small {
        /* font-family: 'Nunito Sans', sans-serif; */
        text-transform: capitalize;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        color: var(--primary-gradient);
        @media (max-width: 767px) {
          font-size: 12px;
        }
      }
    }
    .subscribe {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-blend-mode: overlay, normal;
      background: ${({ statusText }) => (statusText ? '#35bd00' : 'var(--primary-gradient)')};

      padding: 5px 10px;

      svg {
        margin-right: 5px;
      }
      small,
      svg {
        color: #fff;
      }
      &:hover {
        background: #5d5d5d;
      }
    }
    .time-ago,
    .date-publish,
    .count-view {
      &--icon {
        margin-right: 4px;
      }
      &--icon,
      small {
        /* font-family: 'Nunito Sans', sans-serif !important; */
        /* text-transform: lowercase; */
        font-size: 12px;
        font-weight: 200;
        line-height: 1;

        color: #939393;
      }
    }
  }
`;

export default memo(CardSubscribe);
